import { createContext, useContext } from 'react';

interface ModalContextProps {
  closeModal: (e?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}
export const ModalContext = createContext<ModalContextProps>({
  closeModal: () => {},
});

export function useModalContext(): ModalContextProps | never {
  const modalContext = useContext(ModalContext);
  if (!modalContext) {
    throw new Error('useModalContext must be used within ModalContextProvider');
  }
  return modalContext;
}
